import React from "react";
import AttributeIcon from "./AttributeIcon";

type AttributeDescription = {
  title: string;
  content: string;
  icon: string;
  value: number | string;
}

interface IProps {
  attributes: AttributeDescription[];
}

const ArmyUnitAttributeLine = ({
  attributes
}: IProps) => (
  <div style={{ display: "flex", justifyContent: "space-evenly", marginTop: "10px" }}>
    {
      attributes.map(attribute => (
        <div style={{ display: "inline-grid" }}>
          <AttributeIcon
            icon={attribute.icon}
            title={attribute.title}
            content={attribute.content}
            value={attribute.value}
          />
        </div>
      ))
    }
  </div>
)

export default ArmyUnitAttributeLine;
